exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-menu {\n  display: inline-block;\n  vertical-align: top;\n  width: 220px;\n  margin-bottom: 20px; }\n\n.with-margin {\n  margin-right: 1em; }\n\n.card-menu-item {\n  letter-spacing: -0.5px;\n  border-radius: 6px;\n  border: solid 1px #ccc;\n  line-height: 1.2em;\n  height: 102px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  cursor: pointer; }\n  .card-menu-item .item-ico {\n    font-size: 28px;\n    margin-bottom: 15px; }\n  .card-menu-item a {\n    text-decoration: none;\n    display: inline-block;\n    border-radius: inherit; }\n\n.card-link {\n  text-decoration: none; }\n\n.card-menu-item:hover, .card-menu-item:hover a {\n  color: #fff;\n  background: #007BB9; }\n\n.card-menu-item a label {\n  display: block;\n  margin-top: 15px; }\n\n.desc {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #6d6d6d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/menu-blocks/menu-blocks.component.scss
// module id = ../../../../../src/app/core/components/menu-blocks/menu-blocks.component.scss
// module chunks = main